if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {};
        this.cacheElements();
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.addEventListener('click', this.onContainerClick.bind(this));
        this.bindCountrySelectorEvents();
      }

      cacheElements() {
        this.elements.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');

        this.elements.countryInput = this.querySelector('input[name="country_code"]');
        this.elements.localeInput = this.querySelector('input[name="locale_code"]');

        this.elements.button = this.querySelector('button.localization-form__select');
        this.elements.panel = this.querySelector('.disclosure__list-wrapper');
        this.elements.search = this.querySelector('.country-filter__input');
        this.elements.searchLabel = this.querySelector('.country-filter .field__label');
        this.elements.closeButton = this.querySelector('.country-selector__close-button');
        this.elements.resetButton = this.querySelector('.country-filter__reset-button');
        this.elements.searchIcon = this.querySelector('.country-filter__search-icon');
        this.elements.liveRegion = this.querySelector('.sr-country-search-results');
        this.elements.list = this.querySelector('.country-selector__list');
      }

      bindCountrySelectorEvents() {
        if (this.elements.search) {
          if (!this.elements.search.dataset.localizationBound) {
            this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
            this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
            this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
            this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
            this.elements.search.dataset.localizationBound = 'true';
          }
        }
        if (this.elements.closeButton && !this.elements.closeButton.dataset.localizationBound) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
          this.elements.closeButton.dataset.localizationBound = 'true';
        }
        if (this.elements.resetButton && !this.elements.resetButton.dataset.localizationBound) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
          this.elements.resetButton.dataset.localizationBound = 'true';
        }
      }

      setDynamicAccessibilityIds() {
        if (!this.elements.panel || !this.elements.list || !this.elements.button) return;
        const uniqueId = `country-results-${Math.random().toString(36).slice(2, 10)}`;
        this.elements.list.id = uniqueId;
        this.elements.button.setAttribute('aria-controls', uniqueId);
        if (this.elements.search) {
          const searchId = `${uniqueId}-search`;
          this.elements.search.id = searchId;
          this.elements.search.setAttribute('aria-controls', uniqueId);
          this.elements.search.setAttribute('aria-owns', uniqueId);
          if (this.elements.searchLabel) {
            this.elements.searchLabel.setAttribute('for', searchId);
          }
        }
      }

      async ensureCountrySelectorContent() {
        if (!this.elements.panel || this.elements.panel.dataset.contentLoaded === 'true') return;

        const endpoint = this.elements.panel.dataset.countrySelectorEndpoint || `${window.location.pathname}?section_id=country-selector-panel`;
        const response = await fetch(endpoint, { credentials: 'same-origin' });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const panelContent = doc.querySelector('.country-selector-panel');
        if (!panelContent) return;

        this.elements.panel.innerHTML = panelContent.innerHTML;
        this.cacheElements();
        this.setDynamicAccessibilityIds();
        this.bindCountrySelectorEvents();
        this.elements.panel.dataset.contentLoaded = 'true';
      }

      onContainerClick(event) {
        const link = event.target.closest('[data-market-selector-el="marketSelector"]');

        if (link) {
          this.onItemClick(link);
        }
      }

      hidePanel() {
        if (!this.elements.panel) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            event.preventDefault();
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
          case 'ENTER':
            if (document.activeElement !== this.elements.button) return;
            event.preventDefault();
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(link) {
        this.elements.countryInput.value = link.dataset.country;
        this.elements.localeInput.value = link.dataset.locale;

        localStorage.setItem("redirect-modal-dismissed", true);

        const form = this.querySelector('form');

        if (form) {
          form.submit();
        }
      }

      async openSelector() {
        await this.ensureCountrySelectorContent();
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      filterCountries() {
        if (!this.elements.search) return;
        const searchValue = this.elements.search.value.toLowerCase();
        const allCountries = this.querySelectorAll('[data-market-selector-el="item"]');

        allCountries.forEach((item) => {
          const isHidden = !item.dataset.value.toLowerCase().includes(searchValue.toLowerCase());
          item.setAttribute('aria-hidden', String(isHidden));
        });
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
